import {
  movieMetroSm,
  portfolioSm,
  portfolioTempSm,
  defineSm,
  abadcoSm,
  austinRoySm,
  threeGracesSm,
} from '../assets';

export type ProjectsListItem = {
  id: string;
  title: string;
  src: string;
  leftFlex: 0 | 1 | 2 | 3;
  rightFlex: 0 | 1 | 2 | 3;
  thumbnailOffset: string;
  offsetX: number;
  offsetY: number;
};

export const ProjectsList: ProjectsListItem[] = [
  {
    id: 'define-consult',
    title: 'Define',
    src: defineSm,
    leftFlex: 0,
    rightFlex: 1,
    thumbnailOffset: '60%',
    offsetX: 30,
    offsetY: -10,
  },
  {
    id: 'portfolio',
    title: 'Portfolio',
    src: portfolioTempSm,
    leftFlex: 3,
    rightFlex: 1,
    thumbnailOffset: '20%',
    offsetX: 30,
    offsetY: -10,
  },
  {
    id: 'austin-roy',
    title: 'Austin Roy',
    src: austinRoySm,
    leftFlex: 1,
    rightFlex: 3,
    thumbnailOffset: '70%',
    offsetX: 30,
    offsetY: -10,
  },
  {
    id: 'shaquille',
    title: 'Shaquille',
    src: portfolioSm,
    leftFlex: 1,
    rightFlex: 1,
    thumbnailOffset: '10%',
    offsetX: 30,
    offsetY: -10,
  },
  {
    id: 'movie-metro',
    title: 'Movie Metro',
    src: movieMetroSm,
    leftFlex: 1,
    rightFlex: 3,
    thumbnailOffset: '70%',
    offsetX: -10,
    offsetY: 5,
  },
  {
    id: 'abadco',
    title: 'ABadCo',
    src: abadcoSm,
    leftFlex: 1,
    rightFlex: 1,
    thumbnailOffset: '10%',
    offsetX: -10,
    offsetY: -2,
  },
  {
    id: 'three-graces',
    title: 'Three Graces',
    src: threeGracesSm,
    leftFlex: 3,
    rightFlex: 0,
    thumbnailOffset: '30%',
    offsetX: 30,
    offsetY: -2,
  },
];
